/**
 * Suggestion du type DAI au rapprochement (lot 0.14.0, ticket 09).
 *
 * Une ecriture de compta matieres dont le libelle DAE dit « DAI » est une
 * regularisation de stock declaree a part : l'ecran le **suggere**, il ne
 * l'impose jamais — l'operatrice garde le choix du type.
 */
/**
 * La selection appelle-t-elle le type DAI ?
 *
 * Vrai seulement si **toutes** les lignes sont des ecritures douane avec un
 * libelle DAE, que chacune porte « DAI » dans l'une de ses deux colonnes, et
 * qu'aucun libelle n'est une annulation (« ANNUL… », « ANUL… »).
 */
export function selectionAppelleDai(lignes) {
    if (lignes.length === 0)
        return false;
    return lignes.every((ligne) => {
        if (ligne.cote !== 'DOUANE')
            return false;
        const libelles = [ligne.libelleDaeLivraison, ligne.libelleDaeReception].filter((libelle) => libelle !== null && libelle.trim() !== '');
        if (libelles.length === 0)
            return false;
        if (libelles.some((libelle) => ANNULATION.test(libelle.trimStart())))
            return false;
        return libelles.some((libelle) => /DAI/i.test(libelle));
    });
}
/** Un libelle d'annulation : « ANNUL… » ou « ANUL… », casse ignoree. */
const ANNULATION = /^AN?NUL/i;
/**
 * Le type a pre-selectionner : le type **actif** dont le libelle est « DAI »,
 * casse ignoree — ou rien.
 */
export function typeSuggere(lignes, types) {
    if (!selectionAppelleDai(lignes))
        return null;
    return (types.find((type) => type.actif && type.libelle.trim().toUpperCase() === 'DAI')?.id ?? null);
}
//# sourceMappingURL=suggestion-dai.js.map